import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// material-ui
import Typography from '@mui/material/Typography';

// project imports
import DrawerHeaderStyled from './DrawerHeaderStyled';
import Logo from 'components/logo';
import { APP_DEFAULT_PATH } from 'config';

// ==============================|| DRAWER HEADER ||============================== //

export default function DrawerHeader({ open }) {
  return (
    <DrawerHeaderStyled
      open={open}
      sx={{
        minHeight: '60px',
        width: 'initial',
        paddingTop: '8px',
        paddingBottom: '8px',
        paddingLeft: open ? '18px' : 0,
        gap: 1.25
      }}
    >
      <Logo isIcon={!open} sx={{ width: open ? 38 : 35, height: open ? 38 : 35, flexShrink: 0 }} />
      {open && (
        <Typography
          component={Link}
          to={APP_DEFAULT_PATH}
          variant="subtitle1"
          noWrap
          sx={{ color: 'text.primary', fontWeight: 700, lineHeight: 1, textDecoration: 'none' }}
        >
          Aegis WebShield AI
        </Typography>
      )}
    </DrawerHeaderStyled>
  );
}

DrawerHeader.propTypes = { open: PropTypes.bool };
